import { VehicleDeletedReason } from "../models/Vehicle";

// Client-side mirror of GPMetals.Core/Helpers/VehicleDeletionRules.cs.
//
// The server is the authority — it refuses with a 400 either way. This exists so the Delete button
// can be held disabled with the reason shown inline, rather than letting someone confirm a
// destructive action and be told no afterwards. The two must agree, or the button enables for
// something the API then rejects.
export const VEHICLE_DELETION_NOTE_MAX_LENGTH = 500;

export interface VehicleDeletionValidation {
  isValid: boolean;
  // Present only when invalid. Source string, so it doubles as an i18next key.
  message?: string;
  // Normalised: trimmed, and blank becomes undefined so a whitespace-only box is stored as absent
  // rather than as a space that would read as "a note was given".
  note?: string;
}

export function validateVehicleDeletion(
  reason: VehicleDeletedReason | null | undefined,
  note: string | null | undefined
): VehicleDeletionValidation {
  if (reason === null || reason === undefined) {
    return { isValid: false, message: "A reason is required to delete a vehicle" };
  }

  if (!(reason in VehicleDeletedReason)) {
    return { isValid: false, message: "That deletion reason is not recognised" };
  }

  const trimmed = (note ?? "").trim();

  // "Other" carries no information on its own, so it has to be explained.
  if (reason === VehicleDeletedReason.Other && trimmed === "") {
    return { isValid: false, message: "A note is required when the reason is Other" };
  }

  if (trimmed.length > VEHICLE_DELETION_NOTE_MAX_LENGTH) {
    return { isValid: false, message: "The note must be 500 characters or fewer" };
  }

  return { isValid: true, note: trimmed === "" ? undefined : trimmed };
}
